<template>
<span>
<p><span style="background-color:#ffffff"><span style="font-size:10pt">Inhalt der Leistung:</span></span></p>

<ul>
  <li>
    <p><span style="background-color:#ffffff">Leiterquerschnittsberechnung vom Erdleiter in Abh&auml;ngigkeit des Werkstoffes</span></p>
  </li>
</ul>
</span>
</template>

<script>
export default {
  name: "TooltipQuerschnittsberechnung"
}
</script>

<style scoped>

</style>
